import { assertNonNullishProperties } from "api/client/helpers/assertNonNullishProperties";
import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
import { File as DrsFile } from "graphql/_Types";
import { ProcessingStatus } from "types/constants";
import { FileFormat } from "types/FileFormats";
import { FileType } from "types/FileTypes";
import { formatFilename } from "../helpers/formatFilename";
import { getFilePartSize } from "../helpers/getFilePartSize";

type CreateFileInput = Pick<
  DrsFile,
  "id" | "projectId" | "name" | "tenantId"
> & {
  processingStatus: ProcessingStatus;
  fileType: FileType["id"];
  fileFormat: FileFormat["id"];
  size: number;
};
export const fileCreate = djangoClientQueryFactory(
  { path: "/drs/file/", method: "post" },
  {
    formatInput: ({
      id,
      name,
      fileFormat,
      fileType,
      processingStatus,
      projectId,
      size,
      tenantId,
    }: CreateFileInput) => {
      return {
        body: {
          id,
          name: formatFilename(name),
          size,
          project: projectId,
          tenant: tenantId,
          file_type: fileType,
          file_format: fileFormat,
          processing_status: processingStatus,
          uploaded: true,
          date_created: new Date().toISOString(),
          part_size: getFilePartSize(size),
        },
      };
    },
    handleResponse: (res) => {
      const file = res.data;
      assert(file !== undefined, "Expected file to be defined");
      assertNonNullishProperties(file, ["id", "size", "part_size"]);
      return file;
    },
  },
);
